import { createContext, useContext, useState } from 'react';

const FileContext = createContext();

export const FileProvider = ({ children }) => {
  const [recentFiles, setRecentFiles] = useState([]);
  const [processingQueue, setProcessingQueue] = useState([]);
  
  const addProcessedFile = (file) => {
    setRecentFiles(prev => [...prev, file].slice(-10));
  };
  
  const addToQueue = (task) => {
    setProcessingQueue(prev => [...prev, task]);
  };
  
  const removeFromQueue = (taskId) => {
    setProcessingQueue(prev => prev.filter(task => task.id !== taskId));
  };
  
  return (
    <FileContext.Provider value={{ 
      recentFiles, 
      processingQueue,
      addProcessedFile,
      addToQueue,
      removeFromQueue
    }}>
      {children}
    </FileContext.Provider>
  );
};

export const useFileContext = () => useContext(FileContext);